<app-settings-sub-header [headerData]="subHeaderData" [editProfileForm]="editProfileForm"></app-settings-sub-header>
<app-user-profile-wizard (editProfileFormEmitter)="editProfileFormEmitterhandler($event)"></app-user-profile-wizard>
